import { motion } from 'framer-motion';
import { ArrowRight, BrainCircuit, Globe, Rocket } from 'lucide-react';

const values = [
  {
    icon: BrainCircuit,
    title: 'Neural Resonance Systems',
    description:
      'Mapping and enhancing signal-based consciousness models through frequency harmonics, resonance fields, and neural synchronization.',
    points: [
      'Signal-based memory reconstruction',
      'Resonant frequency alignment models',
      'Consciousness-mirroring neural networks',
    ],
  },
  {
    icon: Rocket,
    title: 'Future Focused',
    description: "Building tomorrow's solutions with cutting-edge technology today.",
    points: ['Quantum computing', 'Neural interfaces', 'AI advancement'],
  },
  {
    icon: Globe,
    title: 'Global Impact',
    description: 'Creating technology that transforms lives across the planet.',
    points: ['Worldwide reach', 'Cultural integration', 'Sustainable development'],
  },
];

const fadeUp = {
  initial: { opacity: 0, y: 12 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true },
  transition: { duration: 0.45 },
};

export function AboutValues() {
  return (
    <div className="grid gap-6 md:grid-cols-3">
      {values.map((value, index) => (
        <motion.div
          key={value.title}
          {...fadeUp}
          transition={{ delay: index * 0.06 }}
          className="group flex h-full flex-col rounded-2xl border border-white/10 bg-white/[0.03] p-8 transition-all hover:border-white/20 hover:bg-white/[0.05] hover:shadow-[0_0_28px_var(--glow-purple),0_0_40px_var(--glow-blue)]"
        >
          <div className="mb-5 flex h-12 w-12 items-center justify-center rounded-xl border border-white/12 bg-white/5 transition-colors group-hover:border-white/20 group-hover:bg-white/[0.08]">
            <value.icon className="h-6 w-6 text-white/75" strokeWidth={1.5} />
          </div>

          <h3 className="text-xl font-semibold text-white">{value.title}</h3>
          <p className="mt-3 text-sm leading-relaxed text-white/55">{value.description}</p>

          <ul className="mt-6 space-y-2.5 border-t border-white/8 pt-5">
            {value.points.map((point) => (
              <li key={point} className="flex items-start gap-2 text-sm text-white/45 group-hover:text-white/55">
                <ArrowRight className="mt-0.5 h-3.5 w-3.5 shrink-0 text-white/35" />
                {point}
              </li>
            ))}
          </ul>
        </motion.div>
      ))}
    </div>
  );
}
